export default {
  contextTypes: {
    executeAction() {},
  },

  executeAction(RunnerClass, ...params) {
    this.context.executeAction(RunnerClass, ...params);
  },
};
